import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { AutomacaoExtracaoDadosRequest } from '../../requests/batch-extracao-dados/automacao-extracao-dados.request';
import { ReturnStruct } from '../../structs/return.struct';
import { ListAutomacaoExtracaoDadosResponse } from '../../responses/batch-extracao-dados/list-automacao-extracao-dados.response';
import { GetAutomacaoExtracaoDadosResponse } from '../../responses/batch-extracao-dados/get-automacao-extracao-dados.response';

@Injectable({
  providedIn: 'root',
})
export class AutomacaoExtracaoDadosService extends CommonService {
  // Ajuste a URL base conforme a configuração do seu environment.ts
  // Baseado na rota [Route("[controller]")] onde controller é AutomacaoExtracao
  private readonly apiUrl: string = environment.urlApiBatchExtracaoDados + 'AutomacaoExtracaoDados';

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Endpoint para listar as automações.
   * Corresponde a: [HttpGet] /AutomacaoExtracao?idTipoExtracao=...
   * @param idTipoExtracao (Opcional) Filtro por tipo(s) de extração.
   */
  public listar(idTipoExtracao?: number[]): Observable<ListAutomacaoExtracaoDadosResponse> {
    let params = new HttpParams();
    (idTipoExtracao || []).forEach(id => {
      params = params.append('idTipoExtracao', id.toString());
    });

    return this.httpClient
      .get<ListAutomacaoExtracaoDadosResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para buscar uma automação pelo ID.
   * Corresponde a: [HttpGet] /AutomacaoExtracao/idAutomacaoExtracao/{idAutomacaoExtracao}
   * @param idAutomacaoExtracao ID da automação.
   */
  public getById(idAutomacaoExtracao: number): Observable<GetAutomacaoExtracaoDadosResponse> {
    const url = `${this.apiUrl}/idAutomacaoExtracao/${idAutomacaoExtracao}`;
    return this.httpClient
      .get<GetAutomacaoExtracaoDadosResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para criar uma nova automação.
   * Corresponde a: [HttpPost] /AutomacaoExtracao
   * @param request Dados da nova automação.
   */
  public post(request: AutomacaoExtracaoDadosRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para atualizar uma automação existente.
   * Corresponde a: [HttpPut] /AutomacaoExtracao/idAutomacaoExtracao/{idAutomacaoExtracao}
   * @param idAutomacaoExtracao ID da automação a ser atualizada.
   * @param request Dados atualizados da automação.
   */
  public put(idAutomacaoExtracao: number, request: AutomacaoExtracaoDadosRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idAutomacaoExtracao/${idAutomacaoExtracao}`;
    return this.httpClient
      .put<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para deletar uma automação.
   * Corresponde a: [HttpDelete] /AutomacaoExtracao/idAutomacaoExtracao/{idAutomacaoExtracao}
   * @param idAutomacaoExtracao ID da automação a ser removida.
   */
  public delete(idAutomacaoExtracao: number): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idAutomacaoExtracao/${idAutomacaoExtracao}`;
    return this.httpClient
      .delete<ReturnStruct>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}